import React from 'react';
import { Typography } from '@mui/material';
import Grid from '@mui/material/Grid';

export default function Marjolaine() {
  return (
    <div className="root">
      <Grid
        container 
        direction="row"
        alignItems="stretch"
        spacing={2}
        sx={{
          marginTop: 1,
          marginBottom: 3,
        }}
      >
        <Grid item xs={12} sm={8} md={8}>
          <Typography variant='h1' sx={{flexGrow:2}}>Graphothérapeute certifiée</Typography>
          <Typography variant='body1' sx={{flexGrow:1}}>
            Spécialisée dans la graphothérapie clinique et pathologique des enfants, adolescents et adultes.
          </Typography>
        </Grid>
        <Grid item xs={12} sm={4} md={4}>
          <img style={{maxWidth:'100%'}} src="mbg_photo.png" alt="Marjolaine Benmoussa Graphothérapeute" />
        </Grid>
      </Grid>
    </div>
  )
}

